import Modal from '../modal/Modal';
import Spinner from '../spinner';

const LoadingModal: React.FC = () => (
  <Modal className='p-5'>
    <Spinner />
  </Modal>
);

export default LoadingModal;
